module.exports = "<label class=\"ui-switch\">\n    <input type=\"checkbox\" ng-checked=\"$ctrl.checked\" id=\"{{ $ctrl.id }}\" />\n    <span class=\"ui-slider round\"></span>\n</label>"


//////////////////
// WEBPACK FOOTER
// ./client/app/shared/ui/switchery/switchery.html
// module id = 527
// module chunks = 0